<div class="flex app-tabs" [ngClass]="getContainerClasses()">
  @for (tab of tabs; track tab.value) {
    <!-- Router Link Tab -->
    @if (tab.url !== undefined) {
      <a
        class="flex items-center gap-2 border-b-2 border-transparent cursor-pointer transition-all ease-in-out duration-300"
        (click)="onClickTab(tab)"
        [ngClass]="{
          'px-3': size === 'sm',
          'px-5': size === 'base'
        }"
        [routerLink]="tab.url"
        [routerLinkActive]="'!border-primary-600 text-primary-600'">
        <span class="font-medium">{{ translatePrefix + tab.label | translate }}</span>
      </a>
    } @else {
      <!-- Regular Tab -->
      <div [class]="getTabClasses(tab)" (click)="onClickTab(tab)">
        {{ translatePrefix + tab.label | translate }}

        <!-- Quantity Badge (only for underline type) -->
        @if (type === 'underline' && tab.quantity !== undefined) {
          <div [class]="getQuantityBadgeClasses(tab)">
            {{ tab.quantity }}
          </div>
        }
      </div>
    }
  }
</div>
